import { Table, Button, Divider } from 'antd/lib';
import React from 'react';

class TablaTipoExpedientes extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filterDropdownVisible: false,
      verFiltroApellido: false,
      data: this.props.certificaciones,
      textoBuscarNombre: '',
      textoBuscarApellido: '',
      textoBuscarDocumento: '',
      filtered: false,
    };
  }

  render() {
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'nombre',
        key: 'nombre',
      },
      {
        title: 'Descripcion',
        dataIndex: 'descripcion',
        key: 'descripcion',
      },
      {
        title: 'Acciones',
        key: 'acciones',
        render: (text, record) => (
          <span>
            <Button
              onClick={() =>
                this.props.history.push(
                  `/contravenciones/tipoExpedientes/${record._id}`
                )
              }
            >
              Editar
            </Button>
            <Divider type="vertical" />
            <Button
              type="danger"
              onClick={() => this.props.onDelete(record._id)}
            >
              Eliminar
            </Button>
          </span>
        ),
      },
    ];
    const { tipoExpedientes } = this.props;
    return (
      <Table
        rowKey="_id"
        columns={columns}
        dataSource={tipoExpedientes}
        title={() => (
          <h2 style={{ textAlign: 'center' }}> Tipo Expedientes </h2>
        )}
        locale={{
          emptyText: 'No hay tipo expedientes cargados',
        }}
      />
    );
  }
}

export default TablaTipoExpedientes;
